import { IBlackList, IBlackListRequest } from '../../interfaces/BlackList/IBlackList'
import apiService from '../Api'

export class BlackListService {
  async list(): Promise<{ data: IBlackList[] }> {
    return apiService.get('/internal/website/black-list').then((res) => res.data)
  }

  async create(data: IBlackListRequest): Promise<IBlackList> {
    return apiService.post('/internal/website/black-list', data).then((res) => res.data)
  }

  async update(id: number, data: IBlackListRequest): Promise<IBlackList> {
    return apiService.put(`/internal/website/black-list/${id}`, data).then((res) => res.data)
  }

  async enable(id: number): Promise<IBlackList> {
    return apiService.put(`/internal/website/black-list/enable/${id}`).then((res) => res.data)
  }

  async disable(id: number): Promise<IBlackList> {
    return apiService.put(`/internal/website/black-list/disable/${id}`).then((res) => res.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/internal/website/black-list/${id}`).then((res) => res.data)
  }
}
